import { Api } from "../../Utils/api"
import { v4 as uuid } from 'uuid'
import { encode as base64_encode } from 'base-64'
import { Cidade, Estado, RetAPI } from "../../Utils/Types"
import { DataSearch } from "../../Components/SearchBox/SearchBox"
import { error } from "console"

export type LoginProps = {
    error: boolean,
    msg: string,
    hash?: string,
    name?: string,
    cor_tema?: string,
    tema?: string,
    cor_hover_menu?: string,
    cor_hover_sub_menu?: string,
    dadosEmpresa?: any,
    isLogged?: boolean,
}

export type AttributesProps = {
    ufList: Estado[],
    cidadesList: Cidade[],
}

export const GetUFList = async (): Promise<AttributesProps> => {

    const resp = await Api('/citys/all', 'get', {})
    let estadosList: Estado[] = []
    let cidadesList: Cidade[] = []

    if (resp.data) {
        
        if (resp.data.estados) {
            estadosList = resp.data.estados.map( (item: any) => {
                return {
                    id: item.id,
                    description: item.nome,
                    sigla: item.sigla,
                }
            } )
        }

        if (resp.data.cidades) {
            cidadesList = resp.data.cidades.map( (item: any) => {
                return {
                    id: item.codigo,
                    description: item.nome,
                    uf: item.uf,
                }
            } )
        }
    }

    return {
        ufList: estadosList,
        cidadesList: cidadesList,
    }
}

export const handleLoginClick = async (email: string, password: string, confirmAuth: boolean = false): Promise<LoginProps> => {

    if (!email) {
        return {
            error: true,
            msg: 'E-mail não informado'
        }
    }

    if (!password) {
        return {
            error: true,
            msg: 'Senha não informada'
        }
    }

    let params: any = { email, password }

    if (confirmAuth) {
        params.confirm_auth = "S"
    }

    const random = uuid()

    params.password = base64_encode(params.password + '-' + random)


    // obs: eu adicionei '?' para permitir entrar no sistema sem precisar necessariamente ter esses dados  da empresa, porém fica a questão elas são obrigatorias? 
    // caso seja é preciso retirar as "?" para caso o usuario não tenha essas informações o proprio sistema barre ele no login.

    try {
        const resp = await Api('/auth', 'post', params)

        if (resp.data) {

            if (resp.data.error === '0') {

                let Empresa = {
                    id:resp.data.empresa?.id,
                    razao: resp.data.empresa?.razao,
                    fantasia: resp.data.empresa?.nome_fantasia,
                    rua: resp.data.empresa?.rua,
                    bairro: resp.data.empresa?.bairro,
                    numero: resp.data.empresa?.numero,
                    endereco: resp.data.empresa?.endereco,
                    cidade: resp.data.empresa?.nome_cid,
                    uf: resp.data.empresa?.uf,
                    cep: resp.data.empresa?.cep,
                    compl: resp.data.empresa?.compl,
                    cnpj_cpf: resp.data.empresa?.cnpj_cpf,
                    ie: resp.data.empresa?.ie_rg,
                    url_logo: resp.data.empresa?.url_logo,
                    regime_tributario: resp.data.empresa?.regime_tributario,
                    telefone: resp.data.empresa?.contato?.telefone,
                    celular: resp.data.empresa?.contato?.celular,
                    nome: resp.data.empresa?.contato?.nome,

                }

                return {
                    error: false,
                    msg: '',
                    hash: resp.data.hash,
                    name: resp.data.name,
                    cor_tema: resp.data.cor_tema,
                    tema: resp.data.tema,
                    cor_hover_menu: resp.data.cor_hover_menu,
                    cor_hover_sub_menu: resp.data.cor_hover_sub_menu,
                    dadosEmpresa: Empresa,
                }

            } else {

                return {
                    error: true,
                    msg: resp.data.msg,
                    isLogged: resp.data.isLogged,
                }
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }

        }

    } catch (er) {
        return {
            error: true,
            msg: 'Nenhuma informação retornada: ' + er
        }
    }


}

export const CreatePassword = async (password: string, confirmPassword: string, token: string): Promise<RetAPI> => {

    const resp = await Api('User/Password/create', 'post', {password, confirmPassword, token})

    if (resp.data){
        return {
            error: resp.data.error === "1",
            msg: resp.data.error === "0" ? "" : resp.data.msg
        }
    }

    return {
        error: false,
        msg: ''
    }
}

export const RememberPassword = async (email: string): Promise<RetAPI> => {
    const resp = await Api("Empresa/RememberPassword", "post", {email})

    if (resp.data){
        return {
            error: resp.data.error === "1",
            msg: resp.data.error === "0" ? "" : resp.data.msg
        }
    }else{
        return {
            error: true,
            msg: 'Nenhuma informação retornada'
        }    
    }

    return {
        error: false,
        msg: ''
    }
}

